"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const localeToTranslationsMap = {
    'ar-AE': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-ar-AE"*/ '../../translations/regionswitchertranslations-ar-AE.puff.json'))),
    'de-DE': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-de-DE"*/ '../../translations/regionswitchertranslations-de-DE.puff.json'))),
    'en-AU': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-AU"*/ '../../translations/regionswitchertranslations-en-AU.puff.json'))),
    'en-CA': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-CA"*/ '../../translations/regionswitchertranslations-en-CA.puff.json'))),
    'en-GB': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-GB"*/ '../../translations/regionswitchertranslations-en-GB.puff.json'))),
    'en-IN': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-IN"*/ '../../translations/regionswitchertranslations-en-IN.puff.json'))),
    'en-SG': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-SG"*/ '../../translations/regionswitchertranslations-en-SG.puff.json'))),
    'en-US': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-en-US"*/ '../../translations/regionswitchertranslations-en-US.puff.json'))),
    'es-CO': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-es-CO"*/ '../../translations/regionswitchertranslations-es-CO.puff.json'))),
    'es-ES': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-es-ES"*/ '../../translations/regionswitchertranslations-es-ES.puff.json'))),
    'es-MX': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-es-MX"*/ '../../translations/regionswitchertranslations-es-MX.puff.json'))),
    'es-US': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-es-US"*/ '../../translations/regionswitchertranslations-es-US.puff.json'))),
    'fr-CA': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-fr-CA"*/ '../../translations/regionswitchertranslations-fr-CA.puff.json'))),
    'fr-FR': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-fr-FR"*/ '../../translations/regionswitchertranslations-fr-FR.puff.json'))),
    'hi-IN': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-hi-IN"*/ '../../translations/regionswitchertranslations-hi-IN.puff.json'))),
    'it-IT': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-it-IT"*/ '../../translations/regionswitchertranslations-it-IT.puff.json'))),
    'ja-JP': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-jp-JP"*/ '../../translations/regionswitchertranslations-ja-JP.puff.json'))),
    'ko-KR': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-ko-KR"*/ '../../translations/regionswitchertranslations-ko-KR.puff.json'))),
    'nl-NL': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-nl-NL"*/ '../../translations/regionswitchertranslations-nl-NL.puff.json'))),
    'pl-PL': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-pl-PL"*/ '../../translations/regionswitchertranslations-pl-PL.puff.json'))),
    'pt-BR': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-pt-BR"*/ '../../translations/regionswitchertranslations-pt-BR.puff.json'))),
    'sv-SE': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-sv-SE"*/ '../../translations/regionswitchertranslations-sv-SE.puff.json'))),
    'ta-IN': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-ta-IN"*/ '../../translations/regionswitchertranslations-ta-IN.puff.json'))),
    'th-TH': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-th-TH"*/ '../../translations/regionswitchertranslations-th-TH.puff.json'))),
    'tr-TR': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-tr-TR"*/ '../../translations/regionswitchertranslations-tr-TR.puff.json'))),
    'vi-VN': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-vi-VN"*/ '../../translations/regionswitchertranslations-vi-VN.puff.json'))),
    'zh-CN': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-zh-CN"*/ '../../translations/regionswitchertranslations-zh-CN.puff.json'))),
    'zh-TW': () => Promise.resolve().then(() => __importStar(require(
    /*webpackChunkName: "regionswitchertranslations-zh-TW"*/ '../../translations/regionswitchertranslations-zh-TW.puff.json'))),
};
exports.default = localeToTranslationsMap;
//# sourceMappingURL=localeToTranslationsMap.js.map